import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const coverageToneStyles = StyleSheet.create({
	warning: {
		backgroundColor: THEME.colors.warning.light,
		borderColor: THEME.colors.warning.main,
	},
	danger: {
		backgroundColor: THEME.colors.danger.light,
		borderColor: THEME.colors.danger.main,
	},
	neutral: {
		backgroundColor: THEME.colors.background.main,
		borderColor: THEME.colors.border.main,
	},
});

export const coverageWarningStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: SPACE[12],
		padding: `${SPACE[12]}px ${SPACE[16]}px`,
		borderRadius: THEME.common.borderRadius,
		borderWidth: 1,
		borderStyle: 'solid',
	},
	stacked: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: SPACE[8],
	},
	copy: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		flex: 1,
		minWidth: 240,
	},
	title: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.dark,
	},
	body: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.dark,
		lineHeight: 1.4,
	},
	inlineAction: {
		paddingLeft: 0,
		paddingRight: 0,
	},
});

export const coverageDialogStyles = StyleSheet.create({
	popup: {
		maxWidth: 560,
	},
	columnHeaders: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: SPACE[8],
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.light,
	},
	list: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
		maxHeight: 360,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	row: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: SPACE[16],
		padding: `${SPACE[8]}px 0`,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	selectable: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[12],
	},
	registrantCell: {
		minWidth: 0,
	},
	checkboxPlaceholder: {
		width: SPACE[16],
		flexShrink: 0,
	},
	registrant: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
	},
	name: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	secondary: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		flexShrink: 0,
	},
	note: {
		margin: `${SPACE[8]}px 0 0`,
	},
	footnote: {
		margin: `${SPACE[12]}px 0 0`,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
});

export const startDialogStyles = StyleSheet.create({
	popup: {
		maxWidth: 440,
	},
	note: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
});
